/**
 * Handles faq accordions, open close
 * @returns null or creates class
 */
function doAllPosts() {
  if (customElements.get("all-posts")) return null;

  class AllPosts extends HTMLElement {
    constructor() {
      super();
      this.allTags = this.querySelectorAll(".generalFilter-list li");
      this.selectAllBtn = this.querySelector(
        ".generalFilter-control-list li[data-select-all]"
      );
      this.clearAllBtn = this.querySelector(
        ".generalFilter-control-list li[data-clear-all]"
      );
      this.allPostsBox = this.querySelector(".allPosts-box");
      this.mobFilterTrigger = this.querySelector(".filter-mob-trigger a");
      this.filterWrapper = this.querySelector(".allPosts-allFilters");
      this.closeFilterIcon = this.querySelector(".icon-circle-close");
      if (this.selectAllBtn == null) {
        return undefined;
      }
      this.init();
    }

    init() {
      this.allTags.forEach((tagLi) => {
        const tagLiAnchor = tagLi.querySelector("a");
        tagLiAnchor.addEventListener("click", (e) => {
          e.preventDefault();
          this.handleTagSelect(tagLi);
          this.fetchSection();
        });
      });

      this.selectAllBtn.addEventListener("click", () => {
        this.allTags.forEach((tagLi) => tagLi.setAttribute("data-status", 1));
        this.fetchSection();
      });

      this.clearAllBtn.addEventListener("click", () => {
        this.allTags.forEach((tagLi) => tagLi.setAttribute("data-status", 0));
        this.fetchSection();
      });

      this.mobFilterTrigger.addEventListener("click", () => {
        this.handleMobFilter();
      });

      this.closeFilterIcon.addEventListener("click", () => {
        this.handleMobFilter();
      });
    }

    async fetchSection() {
      const allSelectedTags = [...this.querySelectorAll('li[data-status="1"]')]
        .map((tagLi) => tagLi.querySelector("a").dataset.name)
        .join("+");

      const midUrl =
        allSelectedTags.length > 0 ? `/tagged/${allSelectedTags}` : "";

      const url = `${this.dataset.url}${midUrl}?section_id=${this.dataset.sectionId}`;
      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const articlesBox = html.querySelector(".allPosts-box");
          const articles = html.querySelectorAll(
            ".allPosts-box--inner .allPosts-item"
          );
          if (articles && articles.length > 0) {
            this.allPostsBox.innerHTML = articlesBox.innerHTML;
          }
          if (articles && articles.length === 0) {
            this.allPostsBox.innerHTML = `<p>There are no results for your query`;
          }
        })
        .catch((e) => console.error(e));
    }

    handleTagSelect(element) {
      if (element.dataset.status == "0") {
        element.setAttribute("data-status", 1);
        return;
      }

      if (element.dataset.status == "1") {
        element.setAttribute("data-status", 0);
        return;
      }
    }

    handleMobFilter() {
      if (this.filterWrapper.dataset.status == "0") {
        this.filterWrapper.setAttribute("data-status", 1);
        return;
      }

      this.filterWrapper.setAttribute("data-status", 0);
      return;
    }
  }

  customElements.define("all-posts", AllPosts);
}
doAllPosts();
